import * as constants from "./constants";


export const fetchReportBatches = (data) => ({
  type: constants.FETCH_REPORT_BATCHES,
  data,
});

export const fetchReportBatchesSuccess = (payload) => ({
  type: constants.FETCH_REPORT_BATCHES_SUCCESS,
  payload,
});

export const fetchReportBatchesError = () => ({
  type: constants.FETCH_REPORT_BATCHES_ERROR,
});


export const updateReportBatches = (data) => ({
  type: constants.UPDATE_REPORT_BATCHES,
  data,
});

export const updateReportBatchesSuccess = (payload) => ({
  type: constants.UPDATE_REPORT_BATCHES_SUCCESS,
  payload,
});

export const updateReportBatchesError = (payload) => ({
  type: constants.UPDATE_REPORT_BATCHES_ERROR,
  payload,
});


export const deleteReportBatches = (id) => ({
  type: constants.DELETE_REPORT_BATCHES,
  id,
});

export const deleteReportBatchesSuccess = (id) => ({
  type: constants.DELETE_REPORT_BATCHES_SUCCESS,
  id,
});

export const deleteReportBatchesError = (id) => ({
  type: constants.DELETE_REPORT_BATCHES_ERROR,
  id,
});
